import { FC, forwardRef } from "react";
import { IonListHeader } from "@ionic/react";
import { AllieListProps } from "./List.types";
import { StyledList } from "./List.styles";

export const AllieList: FC<AllieListProps> = forwardRef(({ header, children, ...props }, ref) => (
  <StyledList ref={ref} {...props}>
    {header && <IonListHeader {...header} />}
    {children}
  </StyledList>
));
